import { createContext, useContext, useMemo, useState } from 'react';
import { useConnectedEmails } from '../hooks/useConnectedEmails';
import { useSelectedFromValue } from '../hooks/useSelectedFromValue';
import { useSubjectValue } from '../hooks/useSubjectValue';
import { useEmailPreview } from '../hooks/useEmailPreview';
import { useBodyValue } from '../hooks/useBodyValue';
import { getEditorText } from '../utils/email';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailShareTabContext = /*#__PURE__*/createContext(null);
export const ProvideEmailShareTabContext = ({
  tab,
  children
}) => {
  var _tab$emailSettingsCon, _connectedEmailsData$;
  const connectedEmailsData = useConnectedEmails((_tab$emailSettingsCon = tab.emailSettingsConfig) === null || _tab$emailSettingsCon === void 0 ? void 0 : _tab$emailSettingsCon.query);
  const [selectedFromValue, setSelectedFromValue] = useSelectedFromValue(connectedEmailsData.connectedEmailsLoading, connectedEmailsData.connectedEmails, (_connectedEmailsData$ = connectedEmailsData.emailSettings) === null || _connectedEmailsData$ === void 0 ? void 0 : _connectedEmailsData$.defaultFromEmail);
  const initialEmailValues = tab.initialValues;
  const [selectedToValue, setSelectedToValue] = useState((initialEmailValues === null || initialEmailValues === void 0 ? void 0 : initialEmailValues.toContact) || null);
  const [selectedCcValues, setSelectedCcValues] = useState((initialEmailValues === null || initialEmailValues === void 0 ? void 0 : initialEmailValues.ccContacts) || []);
  const [isCcButtonClicked, setIsCcButtonClicked] = useState(false);
  const {
    subjectValue,
    initialSubjectValue,
    setSubjectValue,
    initialSubjectValueLoading
  } = useSubjectValue(initialEmailValues === null || initialEmailValues === void 0 ? void 0 : initialEmailValues.subject);
  const {
    bodyValue,
    setBodyValue,
    initialBodyValue
  } = useBodyValue({
    initialToContactValue: (initialEmailValues === null || initialEmailValues === void 0 ? void 0 : initialEmailValues.toContact) || null,
    bodyValueParam: (initialEmailValues === null || initialEmailValues === void 0 ? void 0 : initialEmailValues.body) || ''
  });
  const {
    emailPreview,
    emailPreviewLoading,
    emailPreviewError
  } = useEmailPreview(tab.loadEmailPreview, getEditorText(bodyValue));
  const [sendEmailError, setSendEmailError] = useState(null);
  const value = useMemo(() => Object.assign({}, connectedEmailsData, {
    selectedFromValue,
    selectedToValue,
    selectedCcValues,
    subjectValue,
    initialSubjectValueLoading,
    bodyValue,
    emailPreview,
    emailPreviewLoading,
    emailPreviewError,
    sendEmailError,
    updateSelectedFromValue: setSelectedFromValue,
    updateSelectedToValue: setSelectedToValue,
    updateSelectedCcValues: setSelectedCcValues,
    updateSubjectValue: setSubjectValue,
    updateBodyValue: setBodyValue,
    updateSendEmailError: setSendEmailError,
    initialBodyValue,
    initialSubjectValue,
    isCcButtonClicked,
    updateIsCcButtonClicked: setIsCcButtonClicked
  }), [bodyValue, connectedEmailsData, emailPreview, emailPreviewError, emailPreviewLoading, initialBodyValue, initialSubjectValue, initialSubjectValueLoading, isCcButtonClicked, selectedCcValues, selectedFromValue, selectedToValue, sendEmailError, setBodyValue, setSelectedFromValue, setSubjectValue, subjectValue]);
  return /*#__PURE__*/_jsx(EmailShareTabContext.Provider, {
    value: value,
    children: children
  });
};
export const useEmailShareTabContext = () => useContext(EmailShareTabContext);